{
  "app": {
    "title": "Меню"
  },
  "common": {
    "close": "Закрыть",
    "currency": "сум",
    "from": "от",
    "total": "Итого",
    "retry": "Повторить",
    "clear": "Очистить"
  },
  "menu": {
    "allTab": "Все позиции",
    "defaultTitle": "Меню",
    "searchLabel": "Поиск по меню",
    "searchPlaceholder": "Поиск позиций…",
    "searchClear": "Очистить поиск",
    "searchHeading": "Результаты",
    "noResults": "Ничего не найдено",
    "emptyCategory": "В этой категории пока пусто...",
    "emptySearch": "По запросу ничего не найдено",
    "error": "Не удалось загрузить меню",
    "choose": "Выбрать",
    "add": "Добавить",
    "openPhoto": "Открыть фото: {{name}}",
    "addOne": "Добавить одну: {{name}}",
    "removeOne": "Убрать одну: {{name}}",
    "addons": "добавки",
    "detailsAria": "Варианты и добавки: {{name}}",
    "layoutToGrid": "Переключить на плитку",
    "layoutToList": "Переключить на список",
    "categoriesNav": "Категории меню",
    "promoTab": "Акции",
    "promoBadge": "−{{n}}%",
    "promoBadgeUpTo": "до −{{n}}%",
    "promoAria": "Скидка {{badge}}, цена {{price}}",
    "positions": {
      "one": "позиция",
      "few": "позиции",
      "many": "позиций"
    },
    "results": {
      "one": "результат",
      "few": "результата",
      "many": "результатов"
    },
    "variants": {
      "one": "вариант",
      "few": "варианта",
      "many": "вариантов"
    }
  },
  "header": {
    "info": "Информация о заведении",
    "yourTable": "Ваш стол:",
    "quickActions": "Быстрые действия",
    "callWaiter": "Позвать официанта",
    "bill": "Счёт",
    "cartAria": "Корзина: {{count}}, {{total}} {{currency}}"
  },
  "banners": {
    "label": "Акции и предложения",
    "role": "карусель",
    "slideRole": "слайд",
    "slide": "{{n}} из {{total}}",
    "pause": "Остановить автопрокрутку баннеров",
    "play": "Включить автопрокрутку баннеров"
  },
  "item": {
    "variants": "Варианты",
    "required": "Обязательно",
    "chooseGroup": "Выберите: {{name}}",
    "upTo": "до {{n}}",
    "limit": "лимит",
    "groupHint": "«{{name}}»: {{hint}}"
  },
  "cart": {
    "title": "Корзина",
    "overline": "Ваш заказ",
    "submit": "Заказать",
    "sending": "Отправляем…",
    "added": "Добавлено в заказ",
    "created": "Заказ отправлен официанту",
    "ordersRetry": "Не удалось проверить заказы — повторить",
    "sendError": "Не удалось отправить заказ",
    "retryInfo": "Не получилось отправить — попробуйте ещё раз через пару секунд",
    "clearedOnBill": "Корзина очищена",
    "pickOrder": "В какой заказ добавить?",
    "max30": "В одном запросе — не больше 30 позиций",
    "comment": "Комментарий",
    "commentPlaceholder": "Например: без лука",
    "commentFilled": ", заполнен",
    "charsLeft": "осталось {{n}}",
    "orderNo": "Заказ №"
  },
  "bill": {
    "title": "Счёт",
    "overline": "Ваш стол",
    "empty": "Активных заказов пока нет",
    "loading": "Загружаем заказы…",
    "error": "Не удалось загрузить заказы",
    "request": "Запросить счёт",
    "requested": "Счёт запрошен…",
    "coming": "Официант несёт счёт",
    "alreadyRequested": "Счёт уже запрошен, подождите",
    "requestError": "Не удалось запросить счёт",
    "payWith": {
      "CLICK": "Оплатить через CLICK",
      "PAYME": "Оплатить через Payme"
    },
    "payOpening": "Открываем оплату…",
    "payError": "Не удалось открыть оплату. Попробуйте ещё раз",
    "itemPending": "Ждёт подтверждения",
    "itemCancelled": "Отменено",
    "itemsConfirmed": "Позиции подтверждены официантом",
    "ordersList": "Список заказов",
    "guests": "Гостей",
    "waiter": "Официант",
    "serviceFee": "Сервисный сбор",
    "discount": "Скидка"
  },
  "waiter": {
    "called": "Официант вызван",
    "alreadyCalled": "Официанта уже позвали, подождите",
    "error": "Не удалось вызвать официанта",
    "noOrder": "Официанта можно позвать, когда на столе есть заказ",
    "noWaiter": "К заказу ещё не прикреплён официант",
    "pickOrder": "Выберите заказ — придёт его официант",
    "unassigned": "Официант не назначен"
  },
  "status": {
    "CREATED": "Создан",
    "PENDING_APPROVAL": "Ждёт подтверждения",
    "NEW": "Новый",
    "ACCEPTED": "Принят",
    "CONFIRMED": "Принят",
    "IN_PROGRESS": "Готовится",
    "COOKING": "Готовится",
    "PREPARING": "Готовится",
    "READY": "Готово",
    "SERVED": "Подано",
    "DONE": "Готово",
    "COMPLETED": "Готово",
    "CANCELLED": "Отменён",
    "CANCELED": "Отменён"
  },
  "info": {
    "overline": "Заведение",
    "title": "Информация",
    "copied": "Скопировано",
    "wifiSection": "Wi-Fi",
    "wifiName": "Сеть Wi-Fi",
    "copyWifiName": "Скопировать название сети",
    "password": "Пароль",
    "copyPassword": "Скопировать пароль",
    "phone": "Телефон",
    "address": "Адрес",
    "socials": "Социальные сети"
  },
  "notFound": {
    "title": "Меню не найдено",
    "hint": "Проверьте корректность QR-кода или обратитесь к официанту."
  },
  "viewer": {
    "title": "Просмотр изображения",
    "close": "Закрыть просмотр"
  },
  "toast": {
    "dismiss": "Нажмите, чтобы закрыть."
  },
  "lang": {
    "label": "Til / Язык",
    "uz": "UZ — O'zbekcha",
    "ru": "РУ — Русский"
  }
}
